import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidBankAccountNumberWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.client.validation.bank-account-number.message');
    }
}
